import { postRequest } from "../utils/fetch";

const baseUrl = "/apicore/authenticationapi/";
export interface ICreateTempResult {
	success: boolean;
	authToken?: string;
	accountId?: string;
	accountType?: string;
}

export function createTemp(): Promise<ICreateTempResult> {
	return postRequest(
		baseUrl + "createtemp",
		{
			language: window.context.language,
		},
		{
			headers: { "Content-type": "application/json; charset=utf-8" },
		},
	);
}
